<template>
    <div>
        <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" size="mini" :inline="true">
            <el-form-item class="form-title" prop="i_id" :label="$t('companyManageMD_company_id')" style="width: 350px">
                <div class="mrA">{{formData.i_id}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_name" :label="$t('form_corporate_name')" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_name" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_name}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_sname" :label="$t('companyManageMD_company_abbreviation')" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_sname" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_sname}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_ename" :label="$t('companyManageMD_contract_identifier')" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_ename" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_ename}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_enamefull" :label="$t('companyManageMD_english_full_name')" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_enamefull" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_enamefull}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_national" :label="$t('companyManageMD_country')" style="width: 350px" required>
                <el-select v-if="canEdit" v-model="formData.i_national" @change="gjChange" size="mini" style="margin-right: 9px;width:110px; " filterable>
                    <el-option v-for="item in gjList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <div class="mrA" v-else>{{formData.vc_national}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_address" :label="$t('companyManageMD_address')" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_address" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_address}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_eaddress" :label="$t('companyManageMD_english_address')" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_eaddress" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_eaddress}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_fr" :label="$t('companyManageMD_legal_person')" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_fr" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_fr}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_bzid" :label="$t('companyManageMD_local_currency')" style="width: 350px" required>
                <el-select v-if="canEdit" v-model="formData.i_bzid"  @change="bzChange" size="mini" style="margin-right: 9px;width:110px; ">
                    <el-option v-for="item in bzList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <div class="mrA" v-else>{{formData.vc_bzname}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_pricing_unit" label="计价单位" style="width: 350px" required>
                <el-select v-model="formData.vc_pricing_unit" v-if="canEdit" style="margin-right: 9px;width:110px; " filterable clearable size="mini">
                    <el-option　v-for="item in dictList"　:key="item.i_id"　:label="item.vc_name"　:value="item.vc_name">
                    </el-option>
                </el-select>
                <div class="mrA" v-else>{{formData.vc_pricing_unit}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_creditcode" :label="$t('companyManageMD_enterprise_code')" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_creditcode" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_creditcode}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_spell" :label="$t('companyManageMD_abbreviation')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_spell" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_spell}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_kftel" :label="$t('companyManageMD_customer_service_hotline')" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_kftel" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_kftel}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_gstel" :label="$t('companyManageMD_company_office_number')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_gstel" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_gstel}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_site_page" :label="$t('companyManageMD_company_official_website')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_site_page" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_site_page}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_email_ht" :label="$t('companyManageMD_contract_email')" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_email_ht" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_email_ht}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_dsid" :label="$t('companyManageMD_e-commerce_id')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.i_dsid" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.i_dsid}}</div>
            </el-form-item>
<!--            <el-form-item class="form-title" prop="i_fileid" label="邮件落款图标ID" style="width: 350px" >-->
<!--                <el-input v-if="canEdit" v-model="formData.i_fileid" size="mini" placeholder="请输入"></el-input>-->
<!--                <div class="mrA" v-else>{{formData.i_fileid}}</div>-->
<!--            </el-form-item>-->
<!--            <el-form-item class="form-title" prop="i_fileid_ht" label="内贸合同章ID" style="width: 350px" >-->
<!--                <el-input v-if="canEdit" v-model="formData.i_fileid_ht" size="mini" placeholder="请输入"></el-input>-->
<!--                <div class="mrA" v-else>{{formData.i_fileid_ht}}</div>-->
<!--            </el-form-item>-->
<!--            <el-form-item class="form-title" prop="i_fileid_htwx" label="外贸合同章ID" style="width: 350px" >-->
<!--                <el-input v-if="canEdit" v-model="formData.i_fileid_htwx" size="mini" placeholder="请输入"></el-input>-->
<!--                <div class="mrA" v-else>{{formData.i_fileid_htwx}}</div>-->
<!--            </el-form-item>-->
            <el-form-item prop="i_canpresold" :label="$t('companyManageMD_can_it_be_pre_sold')" style="width: 350px" >
                <el-radio-group v-model="formData.i_canpresold" v-if="canEdit">
                    <el-radio  :label="1">{{$t('companyManageMD_can')}}</el-radio>
                    <el-radio  :label="0">{{$t('companyManageMD_cannot')}}</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.i_canpresold==1?$t('companyManageMD_can'):$t('companyManageMD_cannot')}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_type" :label="$t('companyManageMD_company_type')" style="width: 350px" required>
                <el-select v-if="canEdit" v-model="formData.i_type" size="mini" style="margin-right: 9px;width:110px; ">
                    <el-option v-for="item in lxList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <div class="mrA" v-else>{{lxList.find(l=>formData.i_type==l.i_id).vc_name}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_pid" :label="$t('companyManageMD_group_company')" style="width: 350px">
                <el-select v-if="canEdit" v-model="formData.i_pid" filterable clearable :remote="true"
                           :remote-method="jtgssearch" @change="jtgsChange" size="mini" style="margin-right: 9px;width:110px; ">
                    <el-option v-for="item in jtgsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <div class="mrA" v-else>{{formData.vc_pname}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_plat" :label="$t('companyManageMD_attribution_system')" style="width: 350px" required>
                <el-radio-group v-model="formData.vc_plat" v-if="canEdit" :disabled="!!formData.i_pid">
                    <el-radio label="ghw">ghw</el-radio>
                    <el-radio label="havay">havay</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.vc_plat}}</div>
            </el-form-item>
            <el-form-item prop="isuse" :label="$t('companyManageMD_enable_or_not')" style="width: 350px" required>
                <el-radio-group v-model="formData.isuse" v-if="canEdit">
                    <el-radio  :label="1">{{$t('form_correct')}}</el-radio>
                    <el-radio  :label="0">{{$t('form_deny')}}</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.isuse==1?$t('form_correct'):$t('form_deny')}}</div>
            </el-form-item>
            <el-form-item prop="isuse" :label="$t('companyManageMD_is_it_compatible_with_ufida')" style="width: 350px" required>
                <el-radio-group v-model="formData.i_is_sync_to_yy" v-if="canEdit">
                    <el-radio  :label="1">{{$t('form_correct')}}</el-radio>
                    <el-radio  :label="0">{{$t('form_deny')}}</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.i_is_sync_to_yy==1?$t('form_correct'):$t('form_deny')}}</div>
            </el-form-item>
            <el-form-item prop="isuse" :label="$t('companyManageMD_is_it_connected_to_the_north_and_south')" style="width: 350px" required>
                <el-radio-group v-model="formData.i_is_sync_to_nb" v-if="canEdit">
                    <el-radio  :label="1">{{$t('form_correct')}}</el-radio>
                    <el-radio  :label="0">{{$t('form_deny')}}</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.i_is_sync_to_nb==1?$t('form_correct'):$t('form_deny')}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_sign" :label="$t('companyManageMD_company_signature')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_sign" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_sign}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_fax" :label="$t('companyManageMD_fax')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_fax" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_fax}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_khid" :label="$t('companyManageMD_associate_customer_id')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.i_khid" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.i_khid}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_order" :label="$t('companyManageMD_serial_number')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.i_order" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.i_order}}</div>
            </el-form-item>

<!--            <el-form-item class="form-title" prop="title" label="本位币币种" style="width: 350px" required>-->
<!--                <el-input v-if="canEdit" v-model="formData.search" size="mini" placeholder="请输入"></el-input>-->
<!--                <div class="mrA" v-else>{{formData.search}}</div>-->
<!--            </el-form-item>-->
<!--            <el-form-item class="form-title" prop="i_mdid" label="主数据ID" style="width: 350px" required>-->
<!--                <el-input v-if="canEdit" v-model="formData.i_mdid" size="mini" placeholder="请输入"></el-input>-->
<!--                <div class="mrA" v-else>{{formData.i_mdid}}</div>-->
<!--            </el-form-item>-->
            <el-form-item class="form-title" prop="i_fileid" :label="$t('companyManageMD_email_signature_icon_id')" style="width: 350px" >
                <div  id="uploadPhoto">
                    <div style="height:100px ;width: 80px; position: relative;" clsss="uploadBox" >
                        <input type="file" name="files" value="" id="uploadfile1" v-if="vc_fileid==''&&canEdit"
                               class="upload-input uploadfile1" @change="uploadFile($event,'yjlktb')">
                        <img src="@/assets/custom_pic.png" style="height:100px ;width: 80px" v-if="vc_fileid==''&&canEdit">
                        <img :src="vc_fileid" style="height:100px ;width: 80px" v-if="vc_fileid!=''" @click="handlePictureCardPreview(vc_fileid)">
                        <i class="el-icon-circle-close close" @click="closeFile('yjlktb')" v-if="vc_fileid!=''&&canEdit"></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_fileid_ht" :label="$t('companyManageMD_internal_trade_contract_seal_id')" style="width: 350px" >
                <div  id="uploadPhoto">
                    <div style="height:100px ;width: 80px; position: relative;" clsss="uploadBox" >
                        <input type="file" name="files" value="" id="uploadfile1" v-if="vc_fileid_ht==''&&canEdit"
                               class="upload-input uploadfile1" @change="uploadFile($event,'nmhtz')">
                        <img src="@/assets/custom_pic.png" style="height:100px ;width: 80px" v-if="vc_fileid_ht==''&&canEdit">
                        <img :src="vc_fileid_ht" style="height:100px ;width: 80px" v-if="vc_fileid_ht!=''" @click="handlePictureCardPreview(vc_fileid_ht)">
                        <i class="el-icon-circle-close close" @click="closeFile('nmhtz')" v-if="vc_fileid_ht!=''&&canEdit"></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_fileid_htwx" :label="$t('companyManageMD_foreign_trade_contract_seal_id')" style="width: 350px" >
                <div  id="uploadPhoto">
                    <div style="height:100px ;width: 80px; position: relative;" clsss="uploadBox" >
                        <input type="file" name="files" value="" id="uploadfile1" v-if="vc_fileid_htwx==''&&canEdit"
                               class="upload-input uploadfile1" @change="uploadFile($event,'wmhtz')">
                        <img src="@/assets/custom_pic.png" style="height:100px ;width: 80px" v-if="vc_fileid_htwx==''&&canEdit">
                        <img :src="vc_fileid_htwx" style="height:100px ;width: 80px" v-if="vc_fileid_htwx!=''" @click="handlePictureCardPreview(vc_fileid_htwx)">
                        <i class="el-icon-circle-close close" @click="closeFile('wmhtz')" v-if="vc_fileid_htwx!=''&&canEdit"></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_input_person')" style="width: 350px" >
                <div class="mrA" >{{formData.vc_lruname}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="dt_createtime" :label="$t('form_enter_time')" style="width: 350px" >
                <div class="mrA" >{{formData.dt_createtime}}</div>
            </el-form-item>
        </el-form>
        <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <div  class="center">
                <el-button type="primary" @click="save('formData')" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">{{$t('button_save')}}</el-button>
<!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">作废</el-button>-->
<!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">启用</el-button>-->
                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">{{$t('button_edit')}}</el-button>
                <!--                <el-button type="warning" @click="flowSub" :disabled="disabled" size="small" v-if="canEdit">提交审批</el-button>-->
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion,erpplatserver,file_root} from "@/utils/baseUrl";

    export default {
        name: "GsPage",
        components: {},
        props: {
            data:{
                type:Object,
                required: true,
                // default:()=>({})
            }
        },
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                formData:{
                    vc_name:'',
                    vc_sname:'',
                    vc_ename:'',
                    vc_enamefull:'',
                    i_national:'',
                    vc_address:'',
                    vc_eaddress:'',
                    vc_fr:'',
                    i_bzid:'',
                    vc_creditcode:'',
                    vc_kftel:'',
                    vc_email_ht:'',
                    i_type:'',
                    vc_plat:'ghw',
                    isuse:1,
                    i_canpresold:1,
                    i_is_sync_to_yy:0,
                    i_is_sync_to_nb:0,
                    vc_pricing_unit:"",
                },
                canEdit:false,
                disabled:false,
                gjList:[],
                bzList:[],
                lxList:[{i_id:0,vc_name:this.$t('companyManageMD_trading_companies')},{i_id:1,vc_name:this.$t('companyManageMD_entrusted_company')},{i_id:2,vc_name:this.$t('companyManageMD_trade+production_company_(including_filling_business)')},],
                rules:{
                    vc_name:[{required: true,message:this.$t('companyManageMD_the_company_name_cannot_be_empty')}],
                    vc_sname:[{required: true,message:this.$t('companyManageMD_the_company_abbreviation_cannot_be_empty')}],
                    vc_ename:[{required: true,message:this.$t('companyManageMD_the_contract_identifier_cannot_be_empty')}],
                    vc_enamefull:[{required: true,message:this.$t('companyManageMD_the_full_english_name_cannot_be_empty')}],
                    i_national:[{required: true,message:this.$t('companyManageMD_the_country_cannot_be_empty')}],
                    vc_address:[{required: true,message:this.$t('companyManageMD_the_address_cannot_be_empty')}],
                    vc_eaddress:[{required: true,message:this.$t('companyManageMD_the_english_address_cannot_be_empty')}],
                    vc_fr:[{required: true,message:this.$t('companyManageMD_the_legal_representative_cannot_be_left_blank')}],
                    i_bzid:[{required: true,message:this.$t('companyManageMD_currency_cannot_be_empty')}],
                    vc_creditcode:[{required: true,message:this.$t('companyManageMD_enterprise_code_cannot_be_empty')}],
                    vc_kftel:[{required: true,message:this.$t('companyManageMD_customer_service_phone_number_cannot_be_empty')}],
                    vc_email_ht:[{required: true,message:this.$t('companyManageMD_the_contract_email_cannot_be_empty')}],
                    i_type:[{required: true,message:this.$t('companyManageMD_company_type_cannot_be_empty')}],
                    vc_plat:[{required: true,message:this.$t('companyManageMD_group_affiliation_cannot_be_empty')}],
                    isuse:[{required: true,message:this.$t('companyManageMD_whether_to_enable_cannot_be_empty')}],
                },
                // action:erpplatserver+'/system/uploadInvoice',
                dialogImageUrl:'',
                dialogVisible:false,
                jtgsList:[],
                vc_fileid_ht:'',
                vc_fileid:'',
                vc_fileid_htwx:'',
                dictList:[],
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
            //data:{
            //     handler(){
            //         if(this.data.i_id==0){
            //             this.canEdit=true
            //             this.getbzlist();
            //             this.getDqList();
            //             this.now=this.$DateTime.now();
            //             this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
            //             this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
            //             this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            //         }else{
            //             this.formData=JSON.parse(JSON.stringify(this.data))
            //         }
            //         console.log(this.data,'handler',this.formData)
            //
            //     },
            //     immediate:true,
            //     deep:true
            // },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.now=this.$DateTime.now();
            this.$nextTick(() => {
                this.onResize();
            });
            if(this.data.i_id==0){
                this.canEdit=true;
                this.getbzlist();
                this.getDqList();
                this.getDictList();
                this.getGroupCompanyList();
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            }else{
                this.formData=JSON.parse(JSON.stringify(this.data));
                this.vc_fileid=file_root+this.formData.vc_filepath;
                this.vc_fileid_ht=file_root+this.formData.vc_filepath_ht;
                this.vc_fileid_htwx=file_root+this.formData.vc_filepath_htwx;
            }
            // this.formData=JSON.parse(JSON.stringify(this.data));
            // console.log(this.data,'mounted',this.formData)


        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            jtgssearch(val){
                this.jtgs_search=val;
                this.getGroupCompanyList();
            },
            jtgsChange(){
                if(this.formData.i_pid){
                    this.formData.vc_plat=this.jtgsList.find(g=>g.i_id==this.formData.i_pid).vc_plat

                }

            },
            gjChange(){
                this.formData.vc_national=this.gjList.find(g=>g.i_id==this.formData.i_national).vc_name
            },
            bzChange(){
                this.formData.vc_bzname=this.bzList.find(g=>g.i_id==this.formData.i_bzid).vc_name
            },
            handlePictureCardPreview(url) {
                this.dialogImageUrl = url;
                this.dialogVisible = true;
            },
            cancel(){
                this.$emit('close')
            },
            save(formName){
                this.$refs[formName].validate((valid)=>{
                    if(valid){
                        this.addCompany()
                    }else{
                        return false
                    }
                })
            },
            editForm(){
                this.canEdit=true
                this.getbzlist();
                this.getDqList();
                this.getDictList();

                this.getGroupCompanyList();
            },
            //币种
            async getbzlist(){
                let param={

                };
                let res=await API.getbzlist(param);
                if ( res.code == 1 ){
                    this.bzList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //国家
            async getDqList(){
                let param={
                    i_pid:0,
                };
                let res=await API.getDqList(param);
                if ( res.code == 1 ){
                    this.gjList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //集团公司
            async getGroupCompanyList(){
                let param={
                    vc_search:this.jtgs_search
                };
                let res=await API.getGroupCompanyList(param);
                if ( res.code == 1 ){
                    this.jtgsList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //新增公司
            async addCompany(){
                this.disabled=true;
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                let param=this.formData;
                let res=await API.addCompany(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.canEdit=false
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    // this.canEdit=false
                    this.disabled=false;

                }
            },
            closeFile(filetype){
                if(filetype=='nmhtz'){
                    this.vc_fileid_ht=''
                    this.formData.i_fileid_ht=null
                }else if(filetype=='wmhtz'){
                    this.vc_fileid_htwx=''
                    this.formData.i_fileid_htwx=null
                }else if(filetype=='yjlktb'){
                    this. vc_fileid=''
                    this.formData.i_fileid=null
                }
            },
            //单位接口(ji单位)
            async getDictList(){
                let param={
                    vc_type:'unit',
                };
                let res=await API.getDictList(param);
                if (res.code==1){
                    this.dictList=res.data;
                    // this.jzdwList=res.data;
                    //console.log(this.dictList,"this.dictList")
                }
            },
            async uploadFile(e,filetype) {
                if(filetype=='nmhtz'){
                    let that = this;
                    let i = 0;
                    let $files = e.target.files[0];
                    let fileName = $files.name;
                    let type = $files.type;
                    var list = {
                        "image/jpeg": true,
                        "image/png": true,
                        "image/jpg": true,
                        "image/bmp": true,
                        "application/pdf": true
                    };
                    let result = list[type];

                    if ($files) {
                        that.fileName = $files.name;
                        that.fileType = $files.type;
                        that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                    } else {
                        that.fileName = "";
                        that.fileType = "";
                        that.fileUrl = "";
                    }
                    if (that.fileName) {
                        var param = {
                            // "file": fileId,
                            // "fileName": that.fileName,
                            // "IDtype": "",
                            // "type": 1,
                            "style": "kh",
                            "files": $files,
                            //"token":sessionStorage.getItem("token"),
                            //"app": "dsmanage",
                            "vc_app": "kh",
                            "i_appid": 0,
                            // "version": "1.0",
                            // "i_uid": sessionStorage.getItem("userid"),
                            "vc_lruname": sessionStorage.getItem("userid"),
                            "i_lruid": sessionStorage.getItem("userid"),
                            // "i_mid": this.mid
                        };
                        let FD = new FormData();
                        for (let key in param) {
                            FD.append(key, param[key])
                        }
                        let res = await API.uploadFile(param);
                        if (res.code == 1) {
                            // if(filetype=='nmhtz'){
                            that.vc_fileid_ht = file_root + res.data[0].vc_path
                            that.formData.i_fileid_ht = res.data[0].i_id

                            console.log(this.vc_fileid_ht,'vc_fileid_ht')
                        } else if (res.code == -2) {
                            that.$router.push('/login');
                            that.$message.error(res.message);
                        } else {
                            that.$message.error(res.message);
                        }
                    }
                }else if(filetype=='wmhtz'){
                    let that = this;
                    let i = 0;
                    let $files = e.target.files[0];
                    let fileName = $files.name;
                    let type = $files.type;
                    var list = {
                        "image/jpeg": true,
                        "image/png": true,
                        "image/jpg": true,
                        "image/bmp": true,
                        "application/pdf": true
                    };
                    let result = list[type];

                    if ($files) {
                        that.fileName = $files.name;
                        that.fileType = $files.type;
                        that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                    } else {
                        that.fileName = "";
                        that.fileType = "";
                        that.fileUrl = "";
                    }
                    if (that.fileName) {
                        var param = {
                            // "file": fileId,
                            // "fileName": that.fileName,
                            // "IDtype": "",
                            // "type": 1,
                            "style": "kh",
                            "files": $files,
                            //"token":sessionStorage.getItem("token"),
                            //"app": "dsmanage",
                            "vc_app": "kh",
                            "i_appid": 0,
                            // "version": "1.0",
                            // "i_uid": sessionStorage.getItem("userid"),
                            "vc_lruname": sessionStorage.getItem("userid"),
                            "i_lruid": sessionStorage.getItem("userid"),
                            // "i_mid": this.mid
                        };

                        let FD = new FormData();
                        for (let key in param) {
                            FD.append(key, param[key])
                        }
                        let res = await API.uploadFile(param);
                        if (res.code == 1) {
                            that.vc_fileid_htwx = file_root + res.data[0].vc_path
                            that.formData.i_fileid_htwx = res.data[0].i_id
                            console.log(this.vc_fileid_htwx,'vc_fileid_htwx')
                        } else if (res.code == -2) {
                            that.$router.push('/login');
                            that.$message.error(res.message);
                        } else {
                            that.$message.error(res.message);
                        }
                    }
                }else if(filetype=='yjlktb'){
                    let that = this;
                    let i = 0;
                    let $files = e.target.files[0];
                    let fileName = $files.name;
                    let type = $files.type;
                    var list = {
                        "image/jpeg": true,
                        "image/png": true,
                        "image/jpg": true,
                        "image/bmp": true,
                        "application/pdf": true
                    };
                    let result = list[type];

                    if ($files) {
                        that.fileName = $files.name;
                        that.fileType = $files.type;
                        that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                    } else {
                        that.fileName = "";
                        that.fileType = "";
                        that.fileUrl = "";
                    }
                    if (that.fileName) {
                        var param = {
                            // "file": fileId,
                            // "fileName": that.fileName,
                            // "IDtype": "",
                            // "type": 1,
                            "style": "kh",
                            "files": $files,
                            //"token":sessionStorage.getItem("token"),
                            //"app": "dsmanage",
                            "vc_app": "kh",
                            "i_appid": 0,
                            // "version": "1.0",
                            // "i_uid": sessionStorage.getItem("userid"),
                            "vc_lruname":  sessionStorage.getItem("userid"),
                            "i_lruid": sessionStorage.getItem("userid"),
                            // "i_mid": this.mid
                        };

                        let FD = new FormData();
                        for (let key in param) {
                            FD.append(key, param[key])
                        }
                        let res = await API.uploadFile(param);
                        if (res.code == 1) {
                            that.vc_fileid=file_root+res.data[0].vc_path
                            that.formData.i_fileid=res.data[0].i_id
                            console.log(this.vc_fileid,'vc_fileid')
                        } else if (res.code == -2) {
                            that.$router.push('/login');
                            that.$message.error(res.message);
                        } else {
                            that.$message.error(res.message);
                        }
                    }
                }
                // this.$forceUpdate()
            },
        },
    }
</script>

<style lang="scss" scoped>
    .center{
        text-align: center;
    }
    /deep/{
        .el-form-item__content{
            width: calc(100% - 145px);
        }
        .el-select{
            margin-right: 0 !important;
            width: 100% !important;
        }
    }
    .upload-input {
        position: absolute;
        opacity: 0;
        width: 80px;
        height: 100px;
    }
    .close{
        position: absolute;
        top: -5px;
        right: -5px;
    }
</style>